// This is all you.
console.log("This is the site JS");

import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";

Alpine.plugin(intersect);

window.Alpine = Alpine;

// Global State for Menu
Alpine.store("menuOpen", {
    on: false,

    toggle() {
        this.on = !this.on;
    },
});

//libs references the external scripts loaded on page
Alpine.store("extScript", {
    libs: [],
    loadScript(lib) {
        if (this.libs[lib]) {
            return this.libs[lib];
        } else {
            var script = document.createElement("script");
            this.libs[lib] = script;
            script.setAttribute("src", lib);
            document.getElementsByTagName("head")[0].appendChild(script);
            return script;
        }
    },
});

Alpine.start();
